import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import 'lib-flexible/flexible.js'
import axios from 'axios'
import './css/main.css';
import './css/defaultclass.css';



Vue.prototype.axios = axios

Vue.config.productionTip = false

// import tabbar from '../components'
// Vue.component('tabbar',tabbar);

// import {Button} from 'vant'
// // import {Cell,Cellgroup} from 'vant'
// Vue.use(Button);
// import { qrcode } from '/qrcode'
// Vue.use(qrcode);

import { NavBar,Toast,Lazyload,Image,Popup,Icon,Search,Divider,Field,Checkbox,CheckboxGroup,Radio,RadioGroup} from 'vant';


import './plugins/element.js'
Vue.use(NavBar).use(Toast).use(Lazyload).use(Image).use(Popup).use(Icon).use(Search).use(Divider).use(Field).use(Checkbox).use(CheckboxGroup).use(Radio).use(RadioGroup);


import { Card } from 'element-ui';
Vue.use(Card);

// import "babel-polyfill";

// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
// export default vConsole;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

